import styled from "styled-components";

export const Container = styled.main``;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    max-height: 500px;
    overflow-y: auto;

    &::-webkit-scrollbar { 
        display: none;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 30px;
`;

export const ContentImage = styled.div`
    display: flex;
    justify-content: center;
    width: 100px;

    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 1px 0px 5px 0px  ${(props) => props.theme.colors.gray.gray_100};
    padding: 12px 4px;
`;

export const Image = styled.img`
    height: 100px;
    width: 100px;
`;

export const ContentInfor = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Infor = styled.p`
    display: flex;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_200};
        font-weight: 500;
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const FeaturedSection = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;

    padding: 10px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const ContentBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const InforBody = styled.p`
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    width: 100%;
    white-space: nowrap;
    
    span{
        color: ${(props) => props.theme.colors.gray.gray_500};
    }

    p{
        display: flex;
        align-items: center;
    }
`;

export const Description = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    text-align: justify;
`;

export const ContentButton = styled.div`
    display: flex;
    justify-content: end;
`;

export const Button = styled.button`
    display: flex;
    background-color: transparent;
    color: ${(props) => props.theme.colors.primary};
`;

export const Status = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 12px;

    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border: 1px solid ${(props) => (props.theme.colors.success)};
    color: ${(props) => (props.theme.colors.success)};
    
    &.pendente{
        border: 1px solid ${(props) => (props.theme.colors.blue)};
        color: ${(props) => (props.theme.colors.blue)};
    }
    &.atrasado{
        border: 1px solid ${(props) => (props.theme.colors.warning)};
        color: ${(props) => (props.theme.colors.warning)};
    }
    &.cancelado{
        border: 1px solid ${(props) => (props.theme.colors.error)};
        color: ${(props) => (props.theme.colors.error)};
    }
`;

export const Text = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;

export const InforSmall = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 12px;
`;